import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcRolesAndPermissions = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M22.5 14a3.5 3.5 0 0 1-5.109 3.109L14 20.5h-1.5V19l3.391-3.391A3.5 3.5 0 1 1 22.5 14Zm-3 .5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M12.5 7.5c0 1.401-.72 2.634-1.812 3.349a7.013 7.013 0 0 1 3.369 2.394 5.041 5.041 0 0 0 .095 1.984L10.88 18.5H2.5a1 1 0 0 1-1-1 7.003 7.003 0 0 1 4.812-6.651A4 4 0 1 1 12.5 7.5Z",
  fill: "var(--mds-nav-icon-weak)"
})), "IcRolesAndPermissions");

export { IcRolesAndPermissions };
//# sourceMappingURL=ic-roles-and-permissions.js.map
